import React, { useEffect, useRef } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { MatterRouter } from './components/MatterRouter';
import { HowItWorks } from './components/HowItWorks';
import { SocialProof } from './components/SocialProof';
import { About } from './components/About';
import { People } from './components/People';
import { StartOnline } from './components/StartOnline';
import { Insights } from './components/Insights';
import { Contact } from './components/Contact';
import { Newsletter } from './components/Newsletter';
import { Footer } from './components/Footer';
import { StickyContact } from './components/StickyContact';
export function App() {
  const observerRef = useRef<IntersectionObserver | null>(null);
  useEffect(() => {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => {
        el.classList.add('visible');
      });
      return;
    }
    observerRef.current = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observerRef.current?.unobserve(entry.target);
        }
      });
    }, {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.1
    });
    document.querySelectorAll('.reveal, .reveal-stagger').forEach(el => {
      observerRef.current?.observe(el);
    });
    return () => {
      observerRef.current?.disconnect();
    };
  }, []);
  return <div className="min-h-screen bg-tlfc-cream text-tlfc-text font-sans antialiased" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <MatterRouter data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <SocialProof data-id="element-7" />
        <About data-id="element-8" />
        <People data-id="element-9" />
        <StartOnline data-id="element-10" />
        <Insights data-id="element-11" />
        <Contact data-id="element-12" />
        <Newsletter data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
      <StickyContact data-id="element-15" />
    </div>;
}